import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-kenya-black text-kenya-white p-4 mt-auto">
      <div className="container mx-auto text-center">
        <p>© {new Date().getFullYear()} Kenyans in Diaspora Petition Against Bad Governance</p>
      </div>
    </footer>
  );
};

export default Footer;